import { environment } from '../environments/environment';

/** Snippets target this environment's GraphQL endpoint; local dev has no configured root. */
export const graphqlEndpoint = (): string =>
  `${environment.GO_API_ROOT || window.location.origin}/query`;
